import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHTwentySevenResult',
    name: 'PageOneHTwentySevenResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHTwentySeven/result.vue'),
  },
  {
    path: '/IFPageOneHTwentySevenGuide',
    name: 'PageOneHTwentySevenGuide',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHTwentySeven/guide.vue'),
  },
];
